import React from 'react'
const NavBackButton = ({label, handleBackClick, activeLabel}) => {
  return (
    <div className='flex justify-center'>
      <div className='heading-xs-satoshi relative flex w-full items-center justify-center text-center text-purple-900'>
        <div
          className='absolute left-0 top-0 z-20 flex h-8 w-8 items-center justify-center overflow-hidden rounded-lg bg-purple-200'
          onClick={(e) => {
            e.stopPropagation()
            handleBackClick(activeLabel)
          }}
        >
          <svg
            width='16'
            height='16'
            viewBox='0 0 16 16'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
          >
            <path
              d='M7.36607 13.2797L1.96598 7.92956L7.22388 2.72027M14.0339 7.92722L2.16391 7.92722'
              stroke='#7F5D85'
              stroke-linecap='round'
            />
          </svg>
        </div>
        <div className='max-w-[80%]'>{label}</div>
      </div>
    </div>
  )
}

export default NavBackButton
